export default "__VITE_ASSET__2950f669__"